/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SaasEnvironment } from './saasEnvironment';
import { IrrSaasConfig } from './irrSaasConfig';


export interface IrrSaasConfigResponse { 
    /**
     * IRR Config version
     */
    configVersion?: string;
    env?: SaasEnvironment;
    config?: IrrSaasConfig;
}

